// Generat automat din README.md
import React from 'react';

const Input = ({ 
  label, 
  error, 
  helper, 
  icon: Icon, 
  className = '',
  required = false,
  fullWidth = true,
  ...props 
}) => {
  const inputClass = `form-input ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500/20' : ''} ${Icon ? 'pl-9 sm:pl-10' : ''} ${fullWidth ? 'w-full' : ''} ${className}`;

  return (
    <div className="space-y-1.5">
      {label && (
        <label className="form-label">
          <span className="truncate">{label}</span>
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <Icon className="w-4 h-4 text-gray-400 flex-shrink-0" />
          </div>
        )}
        <input className={inputClass} {...props} />
      </div>
      {error && (
        <p className="text-xs sm:text-sm text-red-600 dark:text-red-400 truncate">{error}</p>
      )}
      {helper && !error && (
        <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">{helper}</p>
      )}
    </div>
  );
};

export default Input;
